import Icon from '../components/Icon.vue'

Icon.register({
  tv: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M592 0H48C21.5 0 0 21.5 0 48V368C0 394.5 21.5 416 48 416H293.1V448H133.1C115.4 448 101.1 462.3 101.1 480S115.4 512 133.1 512H517.1C534.8 512 549.1 497.7 549.1 480S534.8 448 517.1 448H357.1V416H592C618.5 416 640 394.5 640 368V48C640 21.5 618.5 0 592 0zM576 352H64V64H576V352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tv.js
// module id = yEFP
// module chunks = 144